<template>
    <md-card class="md-elevation-7" style="margin-top: 20px;">
        <md-card-header class="card-chart md-elevation-5" :data-background-color="dataBackgroundColor">
            <div :id="chartId" class="ct-chart" style="display: contents;"></div>
        </md-card-header>

        <md-card-content md-alignment="left">
            <slot name="content"></slot>
        </md-card-content>

        <md-card-actions md-alignment="left" class="footer">
            <slot name="footer"></slot>
        </md-card-actions>
    </md-card>
</template>

<script>
export default {
    name: 'chart-card',

    props: {
    footerText: {
      type: String,
      default: ''
    },
    headerTitle: {
      type: String,
      default: 'Chart title'
    },
    chartType: {
      type: String,
      default: 'Line' // Line | Pie | Bar
    },
    chartOptions: {
      type: Object,
      default: () => {
        return {}
      }
    },
    chartResponsiveOptions: {
      type: Array,
      default: () => {
        return []
      }
    },
    chartData: {
      type: Object,
      default: () => {
        return {
          labels: [],
          series: []
        }
      }
    },
    dataBackgroundColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      chartId: 'no-id'
    }
  },
  methods: {
    initChart () {
      var chartIdQuery = `#${this.chartId}`
      this.$Chartist[this.chartType](chartIdQuery, this.chartData, this.chartOptions)
    },
    updateChartId () {
      var currentTime = new Date().getTime().toString()
      var randomInt = this.getRandomInt(0, currentTime)
      this.chartId = `div_${randomInt}`
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    }
  },
  mounted () {
    this.updateChartId()
  }
}
</script>

<style>
    .card-chart{
        padding: 0;
        height: 250px;
        width: -webkit-fill-available;
        margin-right: 15px;
        font-size: 14px !important;
        line-height: 1;
    }

    .chart-category{
		margin: 0;
        padding-top: 15px;
		color: #999;
        display: table;
	}

	.chart-title{
		color: black;
		font-size: 200%;
		font-weight: 400;
        display: table;
        padding-top: 15px;
        margin: 0px;
	}

    .ct-chart-bar {
        fill: none;
        stroke-width: 15px;
    }

    .ct-chart-label {
        fill: white;
        color: white;
        font-size: 14px;
        line-height: 2;
    }

    .ct-chart-area {
        stroke: none;
    }

    .ct-chart-line {
        fill: none;
        stroke-width: none;
    }


    .ct-chart-bar {
        fill: none;
    }

    .ct-chart-donut {
        fill: none;
    }

    svg {
        position: static;
        width: 98% !important;
        height: 98% !important;
    }

    .ct-grid{
        stroke: rgba(255, 255, 255, 0.2);
    }
    .ct-label{
        color: rgba(white-color, .7);
    }
    .ct-grid{
        stroke: rgba(255, 255, 255, 0.2);
    }
    .ct-series-a .ct-point,
    .ct-series-a .ct-line,
    .ct-series-a .ct-bar,
    .ct-series-a .ct-slice-donut{
        stroke: rgba(255,255,255,.8);
    }
    .ct-series-a .ct-slice-pie,
    .ct-series-a .ct-area{
        fill: rgba(255,255,255,.4);
    }
    
</style>


// WEBPACK FOOTER //
// src/components/ChartCard.vue